import { EdgeConfiguration } from '@cast/types-omni';

import {
  ControlWithDescription,
  InlineWithDescription,
} from 'components/form-layouts';

import { RffSelect } from '@cast/shared-rff-ui';

import { Stack } from '@cast/design-system';

type EdgeConfigurationSectionProps = {
  edgeConfigurations: EdgeConfiguration[];
};

const NO_EDGE_CONFIGURATIONS_AVAILABLE = 'No edge configurations available';

export const EdgeConfigurationSection = ({
  edgeConfigurations,
}: EdgeConfigurationSectionProps) => {
  return (
    <InlineWithDescription
      description={
        <ControlWithDescription label="Edge configuration">
          Select the edge configuration for this edge location.
        </ControlWithDescription>
      }
      controls={
        <Stack gap={16}>
          <RffSelect
            name="edgeConfigurationId"
            label="Edge configuration"
            inputProps={{
              placeholder: 'Select edge configuration',
            }}
            options={
              edgeConfigurations.length > 0
                ? [
                    ...edgeConfigurations.map((config) => ({
                      id: config.id,
                      name: config.name,
                    })),
                  ]
                : [
                    {
                      id: NO_EDGE_CONFIGURATIONS_AVAILABLE,
                      name: NO_EDGE_CONFIGURATIONS_AVAILABLE,
                    },
                  ]
            }
            optionDisabled={(option) =>
              option.id === NO_EDGE_CONFIGURATIONS_AVAILABLE
            }
            optionValue="id"
            optionLabel="name"
            testId="edge-config-select"
          />
        </Stack>
      }
    />
  );
};
